import { createAction } from '@reduxjs/toolkit';
//import { ErrorObject } from '../StoreConstants';
//import { UserPropType } from './InitialState';

const Types = {
  SHOW_GLOBAL_LOADING: 'SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'HIDE_GLOBAL_LOADING',
}

const Creators = {
  showGlobalLoading: createAction(Types.SHOW_GLOBAL_LOADING),
  hideGlobalLoading: createAction(Types.HIDE_GLOBAL_LOADING),
}

export { Types };
export default Creators;